import * as React    from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { useCommon }    from './providers/common';
import { templates }    from './templates';
import CompletedProject from './templates/completed-project';
import Notfound         from './templates/notfound/components/Notfound';

const Router = function() {
  const params   = useParams();
  const location = useLocation();

  const common = useCommon();

  const pages     = React.useMemo(() => {
    return [
      ...common.pages,
      {
        template: 'profile',
        urlKey:   'profile',
      },
      {
        template: 'watched',
        urlKey:   'prosmotrennye-dveri',
      },
      {
        template: 'bookmarks',
        urlKey:   'izbrannoe',
      },
    ];
  }, [common.pages]);
  const page      = React.useMemo(() => {
    return pages.find(item => item.urlKey === params.page);
  }, [pages, params.page]);
  const Component = React.useMemo(() => {
    if (common.notFoundPath && common.notFoundPath === location.pathname) {
      return Notfound;
    }

    if (!params.page) {
      return templates.home.firstLevel;
    }

    if (!page) {
      return Notfound;
    }

    switch (page.template) {
      case 'completed-project':
        return CompletedProject;

      default: {
        const template = templates[page.template];

        if (params.door) {
          return template?.thirdLevel ?? template?.secondLevel ?? template?.firstLevel;
        }

        if (params.urlKey) {
          return template?.secondLevel ?? template?.firstLevel;
        }

        return template?.firstLevel;
      }
    }
  }, [common.notFoundPath, location.pathname, page, pages, params]);

  return <Component />;
};

export default Router;